// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"_1Pycl","withDialog":"_3WBtQ"};